import React from "react";
import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Switch,
  TextField,
  Typography,
} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import Autocomplete from "@material-ui/lab/Autocomplete";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";
import { cmoMembersList } from "../../../../containers/actions/pharmaCo/purchaseOrderActions";
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#1890ff",
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#1890ff",
    },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "90%",
  },
  textFieldWrapper: {
    marginBottom: theme.spacing(2),
  },
  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    textTransform: "none",
  },
  content: {
    flexGrow: 1,
  },
  securityBox: {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
    alignItems: "center",
    border: "1px solid #D9D9D9",
    borderRadius: "4px",
    padding: "8px",
    // paddingTop: "8px",
    // paddingBottom: "8px",
    marginBottom: "16px",
  },
  inviteBtn: {
    backgroundColor: "#286acf",
    textTransform: "none",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#286acf",
    },
  },
  chip: {
    margin: theme.spacing(0.5),
  },
}));

export default function CDMO({
  setShowComponent,
  profileData,
  brandData,
  setBrandData,
}) {
  const classes = useStyles();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [cdmoAPI, setCdmoAPI] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [accessOption, setAccessOption] = useState("all"); // Default to 'all'
  const [associatedIds, setAssociatedIds] = useState("all");
  const [loginSecurity, setLoginSecurity] = useState({
    two_step_authenticated: false,
    edit_phone_number: false,
    azure_ad_sign_in_enabled: false,
  });

  const [twoStepError, setTwoStepError] = useState(false);
  const [editPhoneError, setEditPhoneError] = useState(false);

  // Store the previous state in session storage when navigating away
  const handleBack = () => {
    // For CMO users, only save login security settings
    // For non-CMO users, save all selections including CMO associations
    const currentState = {
      accessOption: localStorage.getItem("collabType") === "CMO" ? "all" : accessOption,
      associatedIds: localStorage.getItem("collabType") === "CMO" ? "all" : associatedIds,
      selectedOptions: localStorage.getItem("collabType") === "CMO" 
        ? [] 
        : selectedOptions.map((option) => option.organization_id),
      loginSecurity,
    };
    sessionStorage.setItem("cdmoState", JSON.stringify(currentState));
    
    // Navigate back based on user type
    if (localStorage.getItem("collabType") === "CMO") {
      setShowComponent("Profile");
    } else {
      setShowComponent("Brand");
    }
  };

  // Restore selected options when navigating back
  useEffect(() => {
    // If we have previously saved CDMO selections and API data is loaded
    if (cdmoAPI && cdmoAPI.length > 0) {
      // Try to restore from session storage first
      const savedState = sessionStorage.getItem("cdmoState");
      if (savedState) {
        try {
          const parsedState = JSON.parse(savedState);

          // Restore access option
          if (parsedState.accessOption) {
            setAccessOption(parsedState.accessOption);
          }

          // Restore associated IDs
          if (parsedState.associatedIds) {
            setAssociatedIds(parsedState.associatedIds);
          }

          // Restore selected options
          if (
            parsedState.selectedOptions &&
            parsedState.accessOption === "select"
          ) {
            const matchedOptions = cdmoAPI.filter((item) =>
              parsedState.selectedOptions.includes(item.organization_id)
            );

            if (matchedOptions.length > 0) {
              setSelectedOptions(matchedOptions);
            }
          }

          // Restore login security settings
          if (parsedState.loginSecurity) {
            setLoginSecurity(parsedState.loginSecurity);
          }
        } catch (e) {
          console.error("Error restoring CDMO state:", e);
        }
      } else if (associatedIds !== "all" && associatedIds !== "") {
        // Fallback to using associatedIds if no session storage
        const idsArray = associatedIds
          .split(",")
          .map((id) => Number(id.trim()));
        const matchedOptions = cdmoAPI.filter((item) =>
          idsArray.includes(item.organization_id)
        );

        if (matchedOptions.length > 0) {
          setSelectedOptions(matchedOptions);
          setAccessOption("select");
        }
      }
    }
    if (!profileData?.phoneNumber) {
      setLoginSecurity((prev) => ({
        ...prev,
        two_step_authenticated: false,
        edit_phone_number: false,
      }));
      setTwoStepError(false);
      setEditPhoneError(false);
    }
  }, [cdmoAPI]);

  useEffect(() => {
    if (accessOption === "all" && cdmoAPI.length > 0) {
      const allIds = cdmoAPI.map((item) => item.organization_id).join(",");
      // Use functional update to avoid dependency on associatedIds
      setAssociatedIds((prev) => {
        if (prev !== allIds) {
          return allIds;
        }
        return prev;
      });
    }
  }, [accessOption, cdmoAPI]);

  // useEffect(() => {
  //   setLoading(true);

  //   const url = `${appUrl}/user/fetchCdmoDetails`;
  //   // const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/user/fetchCdmoDetails`;
  //   // const url =
  //   //   "https://api.mockfly.dev/mocks/6068d47d-50f1-44a0-bc11-f2a155dab121/fetchCdmoDetails";
  //   axios
  //     .get(url)
  //     .then((res) => {
  //       // throw new Error("Error");
  //       if (res.data.status) {
  //         // console.log("API data", res.data.data);
  //         setCdmoAPI(res.data.data);
  //         setError(null);
  //       } else setCdmoAPI([]);
  //     })
  //     .catch((err) => {
  //       setError(err.message);
  //       console.error(err.message);
  //     })
  //     .finally(() => setLoading(false));
  // }, []);

  useEffect(() => {
    // Skip API call if user is CMO - they don't need to associate with CMOs
    if (localStorage.getItem("collabType") === "CMO") {
      setLoading(false);
      setCdmoAPI([]);
      return;
    }

    setLoading(true);

    const {
      appName,
      network,
      collabType,
      roleName,
      ecosystemId,
      organizationName,
    } = localStorage;

    const url = `${appUrl}/${appName}/${network}/${collabType}/${roleName}/fetchCMOMembers`;

    const payload = {
      collabType,
      roleName,
      organizationName,
      ecosystemId,
    };

    axios
      .post(url, payload)
      .then((res) => {
        if (res.data.status) {
          setCdmoAPI(res.data.CMOMembersWithId);
          setError(null);
        } else {
          setCdmoAPI([]);
        }
      })
      .catch((err) => {
        setError(err.message);
        console.error(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // Handle radio button change
  const handleAccessChange = (event) => {
    const value = event.target.value;
    setAccessOption(value);

    if (value === "all") {
      const allIds = cdmoAPI.map((item) => item.organization_id).join(",");
      // setSelectedOptions([]);
      setSelectedOptions(cdmoAPI);
      setAssociatedIds(allIds);
    } else {
      setSelectedOptions([]);
      setAssociatedIds("");
    }
  };
  useEffect(() => {
    if (accessOption === "all") {
      setSelectedOptions(cdmoAPI);
    }
  }, [cdmoAPI]);

  const createRequestObject = () => {
    // Calculate idsArray inside the function when needed
    const idsArray = Array.from(
      new Set(
        associatedIds
          .split(",") // split by comma
          .map((id) => Number(id.trim())) // convert to number
          .filter((id) => !isNaN(id)) // remove NaN
      )
    );

    return {
      users: [
        {
          full_name: profileData.name,
          email: profileData.email,
          // phoneNumber: `+91 9876543210`,
          phoneNumber: profileData.phoneNumber
            ? `+${profileData.phoneCode} ${profileData.phoneNumber}`
            : "",
          country: profileData.country,
          employee_number: parseInt(profileData.employeeNumber, 10) || 0,
          // employee_number: 14455,
          departmentId: profileData.departmentID,
          collaboratorRoleId: profileData.collaborator_role_id,
          collaboratorRoleName: profileData.collaboratorRoleName,
          cdmo_id: idsArray,
          // cdmo_id:"all",
          // cdmo_id: associatedIds,
          twoStepAuthentication: loginSecurity.two_step_authenticated,
          // editPhoneNumber: false,
          editPhoneNumber: !loginSecurity.edit_phone_number,
          azureADSignIn: loginSecurity.azure_ad_sign_in_enabled,
          collaboratorTypeId: profileData.collaborator_type_id,
          associatedBrandList: brandData?.brands,
          ecosystemTypeName: localStorage.appName,
          associatedProductTypesList: brandData?.products,
          location: profileData.location,
        },
      ],
    };
  };

  const sendInviteRequest = (reqObj) => {
    setError(null);
    setLoading(true);
    const url = `${appUrl}/user/sendInvitationTeamMember`;
    axios
      .post(url, reqObj)
      .then((res) => {
        // throw new Error("mock Error");
        if (res.data.status) {
          // console.log("Invitation sent successfully");
          setShowComponent("InvitationSentScreen");
        } else {
          setError(true);
        }
      })
      .catch((err) => {
        setError(err.message);
        console.error(err.message);
      })
      .finally(() => setLoading(false));
  };

  const handleInvite = () => {
    const reqObj = createRequestObject();
    // console.log(reqObj);
    sendInviteRequest(reqObj);
  };

  const displayLoading = (
    <div style={{ textAlign: "center", marginTop: "1.5em" }}>
      <CircularProgress color="primary" thickness={7} />
    </div>
  );
  const displayError = (
    <Box
      style={{
        border: "2px solid rgb(255,0,0)",
        backgroundColor: "rgb(255,240,240)",

        textAlign: "center",
        padding: "0.8rem",
        fontSize: "0.875rem",
        marginTop: "1.5em",
      }}
    >
      {" "}
      <Typography variant="body2">
        Something went wrong. Please try again later.
      </Typography>
    </Box>
  );

  const displayNoRecordsFound = (
    <Box
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "50px",
        border: "2px solid #000",
        // backgroundColor: "#FFF0F0",
        width: "100%",
        marginTop: "1.5em",
      }}
    >
      <Typography style={{ textAlign: "center" }}>No records found</Typography>
    </Box>
  );

  if (loading) return displayLoading;
  if (localStorage.getItem("collabType") !== "CMO") {
    if (error) return displayError;
    if (!cdmoAPI || !cdmoAPI.length) return displayNoRecordsFound;
  }

  return (
    <Box
      style={{ marginTop: "8px", width: "100%" }}
      className={classes.container}
    >
      <Box className={classes.content}>
        {localStorage.getItem("collabType") !== "CMO" && (
          <Box>
            <Typography
              style={{ fontSize: "16px", fontWeight: 600 }}
              gutterBottom
            >
              Associate CMOs <span style={{ color: "red" }}>*</span>
            </Typography>
            <FormControl style={{ width: "100%" }}>
              <RadioGroup
                row
                value={accessOption}
                onChange={handleAccessChange}
              >
                <FormControlLabel
                  value="all"
                  control={<Radio color="primary" />}
                  label={`Access all CMOs (${cdmoAPI.length} CMOs)`}
                />
                <FormControlLabel
                  value="select"
                  control={<Radio color="primary" />}
                  label="Access select CMOs"
                />
              </RadioGroup>
            </FormControl>
            <FormControl style={{ width: "100%", height: "100%" }}>
              <Autocomplete
                multiple
                value={selectedOptions}
                options={cdmoAPI}
                getOptionLabel={(option) => option?.organization_name || "NA"}
                onChange={(event, value) => {
                  setSelectedOptions(value);
                  setAssociatedIds(
                    value.map((option) => option?.organization_id).join(",")
                  );
                }}
                disabled={accessOption === "all"}
                disableCloseOnSelect
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Start typing to search"
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon fontSize="small" />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                renderOption={(option, { selected }) => (
                  <React.Fragment>
                    <Checkbox
                      checked={selected}
                      style={{ marginRight: 8 }}
                      color="primary"
                    />
                    {option.organization_name}
                  </React.Fragment>
                )}
              />
            </FormControl>
            <FormControl style={{ marginTop: "8px", width: "100%" }}>
              <Typography variant="body1">Your selections</Typography>
              <TextField
                disabled
                size="small"
                minRows={4}
                fullWidth
                value={
                  selectedOptions
                    .map((option) => option?.organization_name)
                    .join(", ") || ""
                } // Display selected names
                variant="outlined"
                InputProps={{
                  readOnly: true,
                }}
                multiline
                style={{ width: "100%" }}
              />
            </FormControl>
          </Box>
        )}

        <Typography
          style={{
            fontSize: "16px",
            fontWeight: 600,
            marginTop: "1em",
            marginBottom: "1em",
          }}
          gutterBottom
        >
          Login Security
        </Typography>
        <Box className={classes.securityBox}>
          <Box>
            <Typography style={{ fontWeight: 500, fontSize: "14px" }}>
              2-Step Authenticated
            </Typography>
            <Typography
              variant="caption"
              style={{ fontSize: "12px", fontWeight: 300 }}
            >
              Authenticate the persion using code sent to the persons device
              (phone number in this case).
            </Typography>
          </Box>
          <Switch
            classes={{ root: classes.root }}
            checked={loginSecurity.two_step_authenticated}
            onChange={(e) => {
              const next = e.target.checked;
              // if (next && !profileData.phoneNumber) {
              //   setTwoStepError(true);
              //   setLoginSecurity({
              //     ...loginSecurity,
              //     two_step_authenticated: false,
              //   });
              //   return;
              // }
              setTwoStepError(false);
              setLoginSecurity({
                ...loginSecurity,
                two_step_authenticated: next,
              });
            }}
          ></Switch>
          {twoStepError && (
            <Typography
              variant="caption"
              style={{ color: "#f44336", marginTop: "4px" }}
            >
              A phone number is required to enable 2‑Step Authentication.
            </Typography>
          )}
        </Box>
        <Box className={classes.securityBox}>
          <Box>
            <Typography style={{ fontWeight: 500, fontSize: "14px" }}>
              Cannot Edit Phone Number
            </Typography>
            <Typography
              variant="caption"
              style={{ fontSize: "12px", fontWeight: 300 }}
            >
              Don't allow the user to edit their phone number. This requires you
              to enter the phone number.
            </Typography>
          </Box>
          <Switch
            classes={{ root: classes.root }}
            checked={loginSecurity.edit_phone_number}
            onChange={(e) => {
              const next = e.target.checked;
              // if (next && !profileData.phoneNumber) {
              //   setEditPhoneError(true);
              //   setLoginSecurity({
              //     ...loginSecurity,
              //     edit_phone_number: false,
              //   });
              //   return;
              // }
              setEditPhoneError(false);
              setLoginSecurity({ ...loginSecurity, edit_phone_number: next });
            }}
          ></Switch>
          {editPhoneError && (
            <Typography
              variant="caption"
              style={{ color: "#f44336", marginTop: "4px" }}
            >
              A phone number is required to enable Cannot Edit Phone Number.
            </Typography>
          )}
        </Box>
        {localStorage.getItem("collabType") !== "CMO" && (
          <Box className={classes.securityBox}>
            <Box>
              <Typography style={{ fontWeight: 500, fontSize: "14px" }}>
                Ping Sign-in Enabled
              </Typography>
              <Typography
                variant="caption"
                style={{ fontSize: "12px", fontWeight: 300 }}
              >
                Enable this option to use Ping credentials to verify the person.
              </Typography>
            </Box>
            <Switch
              classes={{ root: classes.root }}
              checked={loginSecurity.azure_ad_sign_in_enabled}
              onChange={(e) =>
                setLoginSecurity({
                  ...loginSecurity,
                  azure_ad_sign_in_enabled: e.target.checked,
                })
              }
            ></Switch>
          </Box>
        )}
      </Box>

      <Box className={classes.buttonContainer}>
        <Button
          size="small"
          variant="contained"
          disableElevation
          style={{ textTransform: "none" }}
          onClick={handleBack}
        >
          Back
        </Button>

        <Button
          className={classes.inviteBtn}
          variant="contained"
          disabled={associatedIds === ""}
          size="small"
          onClick={handleInvite}
          style={{ textTransform: "none" }}
        >
          Send Invite
        </Button>
      </Box>
    </Box>
  );
}
